/* utils/timing.js */
/**
 * Ultra-optimized scroll debounce using requestAnimationFrame.
 * Ensures the callback runs at most once per frame (16ms),
 * eliminating CPU spikes and layout thrashing.
 */
export const debounceRAF = (fn) => {
    let scheduled = false;
    let lastArgs = null;

    return (...args) => {
        lastArgs = args;

        if (!scheduled) {
            scheduled = true;

            requestAnimationFrame(() => {
                fn.apply(null, lastArgs);
                scheduled = false;
            });
        }
    };
};